import electrical from "@assets/icons/electrical.svg";
import network from "@assets/icons/network.svg";
import Icon from "@components/global/new/Icon/Icon";
import { useRackEquipmentConnections3, useRackItemEquipmentConnections3 } from "@mobx/hooks/useEquipmentConnections";
import usePlaceID3 from "@mobx/hooks/usePlaceID";
import { ConsumerKind3 } from "@mobx/store/connections";
import { IBuilding, IRack, IRackItem3 } from "@mobx/store/locations/types";
import { EQUIPMENT_TYPE } from "@store/Equipments/actionTypes";
import cn from "classnames";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import ConnectionInfo3 from "../ConnectionInfo3";
import styles from "./BackIcon.module.scss";

interface IBackIcon3Props {
  readonly type: EQUIPMENT_TYPE;
  readonly kind?: ConsumerKind3;
  readonly item?: IRackItem3 | IRack | IBuilding;
}

const useControl = (props: IBackIcon3Props) => {
  const { placeID } = usePlaceID3(true);

  const rackItemEq = useRackItemEquipmentConnections3(props.type, placeID);
  const rackEq = useRackEquipmentConnections3(props.type, placeID);
  const eq = useMemo(() => {
    const kind = props.kind ?? "section";
    if (kind === "section" || kind === "miner") return rackItemEq?.[(props.item as IRackItem3).id];
    if (kind === "rack") return rackEq?.[(props.item as IRack).id]
  }, [props.item, props.kind, rackEq, rackItemEq])

  return { eq };
};


const BackIcon3 = observer((props: IBackIcon3Props) => {
  const ctrl = useControl(props);
  const isElectrical = props.type === EQUIPMENT_TYPE.ELECTRICAL;

  return (
    <div className={cn(styles.icon, {})}>
      <Icon src={isElectrical ? electrical : network} noHover />

      {!!ctrl.eq && (
        <ConnectionInfo3
          item={props.kind !== "rack" ? props.item as IRackItem3 : undefined}
          eq={ctrl.eq}
          type={props.type}
        >
          <div
            className={cn(styles.overlay)}
            style={{
              backgroundColor: ctrl.eq.color,
            }}
          >
            {ctrl.eq.num}
          </div>
        </ConnectionInfo3>
      )}
    </div>
  );
});

BackIcon3.displayName = "BackIcon3";

export default BackIcon3;
